// extracted by mini-css-extract-plugin
var _1 = "UserRow-module__animateUploadProgressBarWidth--Zhf_F";
var _2 = "UserRow-module__animatedBackground--bu_u2";
var _3 = "UserRow-module__avatarContainer--JVn_C";
var _4 = "UserRow-module__badgeContainer--BvU7X";
var _5 = "UserRow-module__infoContainer--LQlpC";
var _6 = "UserRow-module__innerContainer--FHkUh";
var _7 = "UserRow-module__name--NLj_B";
var _8 = "UserRow-module__nameContainer--g3eJq";
var _9 = "UserRow-module__title--USq0O";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "avatarContainer", _4 as "badgeContainer", _5 as "infoContainer", _6 as "innerContainer", _7 as "name", _8 as "nameContainer", _9 as "title" }
